// src/pages/SafetyTips.js
import React from "react";
import "../styles/SafetyTips.css";

import SafetyTipCard from "../components/SafetyTipCard";

import safetyTipsData from "../data/safteyTipsData";

const SafetyTips = () => {
  return (
    <div className="safety-page">
      <h2>Safety Tips</h2>
      <p className="safety-intro">
        Enjoy your celebrations with joy and safety. Follow these tips for a safe and happy experience!
      </p>

      <div className="tips-grid">
        {safetyTipsData.map((tip, idx) => (
          <SafetyTipCard key={idx} {...tip} />
        ))}
      </div>

      <p className="safety-footer">
        Celebrate Diwali with joy, light, and love — not risk. Stay safe, stay responsible, and spread happiness all around!
      </p>
    </div>
  );
};

export default SafetyTips;
